function updateCartCount(cart) {
    console.log('Updating cart count with cart data:', cart);

    const cartIconHeader = document.querySelector('#cart-icon-header');
    if (!cartIconHeader) {
        console.warn('Cart icon header not found in DOM');
        return;
    }

    let cartCount = cartIconHeader.querySelector('span');
    const itemCount = cart && cart.item_count !== undefined ? cart.item_count : 0;
    console.log('Item count:', itemCount);

    // Always create span if it doesn't exist
    if (!cartCount) {
        cartCount = document.createElement('span');
        cartCount.setAttribute('aria-hidden', 'true');
        cartIconHeader.appendChild(cartCount);
        console.log('Created new cart count span');
    }

    // Track previous item count globally
    const previousItemCount = window.__previousCartItemCount || 0;
    window.__previousCartItemCount = itemCount;

    if (itemCount > 0) {
        cartCount.textContent = itemCount;
        cartCount.style.display = '';
        console.log('Set cart count to:', itemCount);
    } else {
        console.log('Hid cart count (itemCount <= 0)');

        // Only reload if itemCount dropped to 0 from something > 0
        if (previousItemCount > 0) {
            console.log('Cart was not empty before — reloading once.');
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } else {
            console.log('Cart is already empty, not reloading.');
        }
    }
}


// Enhanced updateCart function
// async function updateCart(formData) {

//   console.log('form data received in the update function:', formData);
//   console.log('Adding to cart...', Object.fromEntries(formData));

//   // Get required data from form or DOM
//   const quantity = parseInt(formData.get('quantity')) || 1;
//   console.log('Quantity inside update function:', quantity);
//   const variantId = formData.get('id');
//   console.log('varinat id inside update function:', variantId);

//   const formElement = await formData.get('form-element') || document.activeElement.closest('form');

//   console.log('form element inside update function:', formElement);

//   // Get product handle from hidden input or data attribute
//   let productHandle = formData.get('product_handle') || 
//                      formElement?.querySelector('[name="product_handle"]')?.value ||
//                      formElement?.dataset.productHandle ||
//                      window.location.pathname.split('/').filter(Boolean).pop();

//   console.log('Product handle inside update fucn:', productHandle);

//   if (!variantId) {
//     console.error('Variant ID is missing from form data');
//     showErrorNotification('Please select a product variant.');
//     return;
//   }

//   if (!productHandle) {
//     console.error('Product handle could not be determined');
//     showErrorNotification('Product information is missing. Please try again.');
//     return;
//   }

//   // First check inventory without adding to cart
//   fetch(`${window.Shopify.routes.root}products/${productHandle}.js`)
//     .then(response => {
//       console.log('first Response from product fetch:', response);
//       if (!response.ok) throw new Error('Product not found');
//       return response.json();
//     })
//     .then(product => {
//       const variant = product.variants.find(v => v.id === parseInt(variantId));
//       if (!variant) throw new Error('Variant not found');

//       // Check inventory policy and quantity
//       if (!variant.available) {
//         throw new Error('This variant is not available');
//       }

//       if (variant.inventory_management && 
//           variant.inventory_policy === 'deny' && 
//           variant.inventory_quantity < quantity) {
//         const availableQty = variant.inventory_quantity;
//         if (availableQty > 0) {
//           showNotification(`Only ${availableQty} items available. Quantity adjusted.`);
//           formData.set('quantity', availableQty);
//         } else {
//           throw new Error('This item is out of stock');
//         }
//       }

//       // Proceed with adding to cart
//       console.log('FormData as object before add to cart:', Object.fromEntries(formData));

//       const cartFormData = new FormData();
//       cartFormData.append('id', formData.get('id'));
//       cartFormData.append('quantity', formData.get('quantity'));

//       // Optionally include custom properties (e.g., Colour, Boot Size)
//       if (formData.get('Colour') || formData.get('Boot Size')) {
//       cartFormData.append('properties[Colour]', formData.get('Colour') || '');
//       cartFormData.append('properties[Boot Size]', formData.get('Boot Size') || '');
//       }

// // return fetch(`${window.Shopify.routes.root}cart/add.js`, {
// //   method: 'POST',
// //   body: cartFormData, // Use FormData directly
// //   headers: {
// //     'X-Requested-With': 'XMLHttpRequest',
// //   },
// // });

//       return cartFormData;

//     })
//     .then(response => {
//       console.log('response after add to cart:', response);
//       if (!response.ok) throw new Error('Failed to add to cart');
//       return response.json();
//     })
//     .then(item => {
//       console.log('Item added to cart:', item);
//       // Get updated cart
//       return fetch(`${window.Shopify.routes.root}cart.js`)
//         .then(response => response.json())
//         .then(cart => {
//           updateCartCount(cart);
//           return { cart, item };
//         });
//     })
//     .then(({ cart, item }) => {
//       // Update cart notification
//       const cartNotification = document.querySelector('cart-notification');
//       if (cartNotification) {
//         // Fetch updated cart notification HTML
//         return fetch(`${window.Shopify.routes.root}?section_id=cart-notification`)
//           .then(response => response.text())
//           .then(text => {
//             const parser = new DOMParser();
//             const doc = parser.parseFromString(text, 'text/html');
//             const newNotification = doc.querySelector('cart-notification');

//             if (newNotification) {
//               cartNotification.innerHTML = newNotification.innerHTML;
//               cartNotification.show();
//             }
//           });
//       }
//     })
//     .catch(error => {
//       console.error('Error in cart update process:', error);
//       // showErrorNotification(error.message || 'Failed to add item to cart. Please try again.');
//     });
// }

async function updateCart() {
    try {
        // Fetch updated cart data
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        if (!cartResponse.ok) {
            throw new Error('Failed to fetch cart data');
        }

        const cart = await cartResponse.json();
        console.log('Updated cart:', cart);

        // Update cart count
        updateCartCount(cart);


    } catch (error) {
        console.error('Error in cart update process:', error);
        showErrorNotification(error.message || 'Failed to update cart. Please try again.');
    }
}

// Helper functions
function showNotification(message) {
    const cartIconHeader = document.querySelector('#cart-icon-header');
    if (!cartIconHeader) {
        console.warn('Cart icon not found for notification placement.');
        return;
    }

    const notification = document.createElement('div');
    notification.className = 'inventory-notification';
    notification.textContent = message;
    cartIconHeader.appendChild(notification); // Attach to cart icon
    setTimeout(() => notification.remove(), 3000);
}


function showErrorNotification(message) {
    const notification = document.createElement('div');
    notification.className = 'inventory-notification error';
    notification.textContent = message;
    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 3000);
}

// Initialize
document.addEventListener('DOMContentLoaded', function () {
    // Add styles for notifications
const style = document.createElement('style');
style.textContent = `
  #cart-icon-header {
    position: relative; /* Needed to anchor absolute positioning */
  }
  .inventory-notification {
    position: absolute;
    top: -10px;
    right: 40px;
 background: #fff;
          padding: 15px 20px;
          border-radius: 4px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    z-index: 10;
    animation: slideIn 0.3s ease-out;
  
    white-space: nowrap;
  }
  .inventory-notification.error {
    background: #ffe6e6;
    color: #d30000;
  }
  @keyframes slideIn {
    from { transform: translateY(-10px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
`;
document.head.appendChild(style);

    // Event delegation for all add-to-cart forms
    // document.addEventListener('submit', function(e) {
    //   if (e.target.matches('form[action="/cart/add"]')) {
    //     e.preventDefault();
    //     const formData = new FormData(e.target);
    //     formData.set('form-element', e.target); // Store form reference
    //     console.log('Form data before send to update functin', formData);
    //     updateCart(formData);
    //   }
    // });

    // Initialize cart count on page load
    fetch(`${window.Shopify.routes.root}cart.js`)
        .then(response => response.json())
        .then(cart => updateCartCount(cart))
        .catch(error => console.error('Error loading cart:', error));
});


// Helper function to show notifications
function showNotification(message) {
    const cartIconHeader = document.querySelector('#cart-icon-header');
    if (!cartIconHeader) {
        console.warn('Cart icon not found for notification placement.');
        return;
    }

    const notification = document.createElement('div');
    notification.className = 'inventory-notification';
    notification.textContent = message;
    cartIconHeader.appendChild(notification); // Attach to cart icon
    setTimeout(() => notification.remove(), 3000);
}


// Helper function for error notifications
function showErrorNotification(message) {
    const notification = document.createElement('div');
    notification.className = 'inventory-notification error';
    notification.textContent = message;
    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 3000);
}

function handleRemoveItem(event) {
    event.preventDefault();

    console.log("remove item funbction called");
    const removeButton = event.target.closest('a.item-remove');
    if (!removeButton) return;

    const removeUrl = removeButton.href;
    console.log('Removing item:', removeUrl);

    fetch(removeUrl)
        .then(response => response.text())
        .then(() => {
            // After removal, get updated cart state
            fetch(window.Shopify.routes.root + 'cart.js')
                .then(response => response.json())
                .then(cart => {
                    console.log('Cart state after removal:', cart);
                    updateCartCount(cart);
                })
                .catch(error => {
                    console.error('Error fetching cart after removal:', error);
                });
        })
        .catch(error => {
            console.error('Error removing item:', error);
        });
}

// Add event listener to all add to cart forms
document.addEventListener('DOMContentLoaded', function () {
    console.log('Initializing cart update functionality');

    // Add styles for inventory notification
const style = document.createElement('style');
style.textContent = `
  #cart-icon-header {
    position: relative; /* Needed to anchor absolute positioning */
  }
  .inventory-notification {
    position: absolute;
    top: -10px;
    right: 40px;
   background: #fff;
          padding: 15px 20px;
          border-radius: 4px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    z-index: 10;
    animation: slideIn 0.3s ease-out;
 
    white-space: nowrap;
  }
  .inventory-notification.error {
    background: #ffe6e6;
    color: #d30000;
  }
  @keyframes slideIn {
    from { transform: translateY(-10px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
`;
document.head.appendChild(style);

    // Initialize cart count
    fetch(`${window.Shopify.routes.root}cart.js`)
        .then(response => response.json())
        .then(cart => updateCartCount(cart))
        .catch(error => console.error('Error loading cart:', error));

    // Attach submit handler to all add-to-cart forms
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
    addToCartForms.forEach(form => {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            sessionStorage.setItem('itemJustAddedToCart', 'true');
            setTimeout(() => {
                window.location.reload();
            }, 1200);
        });
    });

    // Handle remove buttons
    document.addEventListener('click', function (e) {
        if (e.target.closest('.item-remove')) {
            handleRemoveItem(e);
        }
    });

    // ✅ THIS WORKS NOW
    if (sessionStorage.getItem('itemJustAddedToCart') === 'true') {
        sessionStorage.removeItem('itemJustAddedToCart');
        console.log("item is just added to cart");
        const cartIconHeader = document.querySelector('#cart-icon-header');
        if (cartIconHeader) {
            cartIconHeader.click(); // Optional: open drawer
        }
        showNotification('Item successfully added to cart!');
    }
});


